// extracted by mini-css-extract-plugin
module.exports = {"main":"Layout_main__E16O_","footer":"Layout_footer__VvDLC","max-width-container":"Layout_max-width-container__JVfdh","page-container":"Layout_page-container__LLXvk"};